import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import loginUser from "../../utils/authService";
import { CATEGORY_ADD_URL, CATEGORY_DETAILS_URL, CATEGORY_IMAGE_URL } from "../../utils/Constant";
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';
import "react-toastify/dist/ReactToastify.css";
import { categoryList } from "../../utils/Helper";

const CreateCategoryPage = () => {
  const navigate = useNavigate();
  const { categoryId } = useParams();
  const authToken = useSelector(state => state.token);
  useEffect(() => {
    if (!authToken) {
      navigate('/login')
    }
  }, []);

  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [newCategoryId, setNewCategoryId] = useState(null);
  const [categoryIds, setCategoryIds] = useState("");
  const [selectCategory, setSelectCategory] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [slug, setSlug] = useState("");
  const [categoryDescription, setCategoryDescription] = useState("");
  const [parentCategory, setParentCategory] = useState("None");
  const [status, setStatus] = useState("Publish");
  const [categoryImage, setCategoryImage] = useState(null);
  const [category, setCategory] = useState([]);

  useEffect(() => {
    setNewCategoryId(categoryId)
    if (authToken) {
      const fetchDetails = async () => {
        try {
          setNewCategoryId(categoryId)
          if (categoryId) {
            showToast(true, "Data Loading. Please wait..", "info");
          }
          const response = await fetch(`${CATEGORY_DETAILS_URL}/${categoryId}`, {
            headers: {
              Authorization: `Bearer ${authToken.token}`,
            },
          });
          const data = await response.json();
          //console.log("details:::", data)
          setCategoryName(data.categoryName || "")
          setSlug(data.categorySlug || "")
          setCategoryDescription(data.categoryDescription || "")
          setParentCategory(data.categoryName || "")
          setStatus(data.categoryName || "")
          setCategoryImage(data.categoryImage || "")
          setSelectCategory(data.data.categoryId.categoryName || "");
          setImagePreview(
            data.data.categoryImage ? URL.createObjectURL(data.data.categoryImage) : null
          );
        } catch (error) {
          //console.error("Error fetching product:", error);
        }
      };
      fetchDetails();
    } else {
      navigate("/login");
    }
  }, [])

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setImagePreview(file ? URL.createObjectURL(file) : null);
    setCategoryImage(file)
  };

  useEffect(() => {
    const fetchLists = async () => {
      try {
        const [categoryData] = await Promise.all([
          categoryList(authToken),
        ]);
        setCategory(categoryData);
      } catch (error) { }
    };
    fetchLists();
  }, []);
  const showToast = (loading, message, type, errors) => {
    let errorMessage = "";

    if (errors && errors.length > 0) {
      errorMessage = (
        <ul>
          {errors.map((error, index) => (
            <li key={index}>{error.msg}</li>
          ))}
        </ul>
      );
    }
    toast[type](
      <div>
        {loading} {message} {errorMessage}
      </div>,
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000, // milliseconds
      }
    );
  };
  //console.log("inital Val:::", categoryName,
    // slug,
    // categoryDescription,
    // parentCategory,
    // status,
    // categoryImage
  //)
  //console.log("setCategory", category)

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("categoryName", categoryName);
    formData.append("categorySlug", slug);
    formData.append("categoryDescription", categoryDescription);
    formData.append("parentCategory", categoryIds);
    formData.append("status", status);
    formData.append("categoryImage", categoryImage);

    try {
      setLoading(true);
      showToast(true, "In Progress. Please wait..", "info");
      const response = await fetch(
        newCategoryId ? `${CATEGORY_DETAILS_URL}/${newCategoryId}` :
          CATEGORY_ADD_URL, {
        method: newCategoryId ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${authToken.token}`,
        },
        body: formData,
      });

      const data = await response.json();
      //console.log("data::::", data)

      // Handle success or display error messages
      setLoading(false);

      if (response.ok) {
        showToast(true, "Auction updated successfully!", "success");
        // Navigate to /categories/list on success
        setTimeout(() => {
          navigate("/categories/list");
        }, 3000);
      } else {
        showToast("Loading:", "An error occurred.", "error", data.errors);
        //showToast(true, data.error, "error");
      }
    } catch (error) {
      console.error("Category Creation Error:", error.message);
      showToast(true, error.message, "error");
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Create Category</h3>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            {/* Your form fields */}
            <div className="form-group">
              <label htmlFor="categoryName">Category Name</label>
              <input
                type="text"
                className="form-control"
                id="categoryName"
                name="categoryName"
                placeholder="Category Name"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              // onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="slug">Slug</label>
              <input
                type="text"
                className="form-control"
                id="slug"
                name="slug"
                placeholder="Slug"
                value={slug}
                onChange={(e) => setSlug(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="categoryDescription">Category Description</label>
              <textarea
                className="form-control"
                id="categoryDescription"
                name="categoryDescription"
                placeholder="Category Description"
                value={categoryDescription}
                onChange={(e) => setCategoryDescription(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label htmlFor="parentCategory">Select Parent Category</label>
              <select
                className="form-control custom-select"
                id="parentCategory"
                name="parentCategory"
                value={selectCategory}
                onChange={(e) => {
                  setSelectCategory(e.target.value);
                  const categoryObject = category.find(
                    (cat) => cat.categoryName === e.target.value
                  );
                  setCategoryIds(categoryObject._id);
                }}
              >
                <option value="">Select Category</option>
                {category.map((item) => (
                  <option key={item._id} value={item.categoryName}>
                    {item.categoryName}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="status">Status</label>
              <select
                className="form-control custom-select"
                id="status"
                name="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="1">Publish</option>
                <option value="0">Inactive</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="categoryImage">Category Thumbnail</label>
              <input
                type="file"
                className="form-control-file"
                id="categoryImage"
                name="categoryImage"
                // value={categoryImage}
                onChange={handleFileChange}
              />
              {/* Display image preview */}
              {imagePreview ? (
                <div>
                  <br></br>
                  <img
                    src={imagePreview}
                    alt="Preview"
                    style={{ width: "100%", height: "200px" }}
                  />
                </div>
              ) : (
                <div>
                  <br></br>
                  <img
                    src={`${CATEGORY_IMAGE_URL}/${categoryImage}`}
                    alt="Preview"
                    style={{ width: "15%", height: "150px" }}
                  />
                </div>
              )}
            </div>

            <div className="form-group">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Adding Category..." : "Add Category"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default CreateCategoryPage;
